module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "ui active centered inline large loader"
  })]) : _c('div', {
    staticClass: "ui grid",
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "ten wide column"
  }, [_c('div', {
    staticClass: "field",
    staticStyle: {
      "padding": "15px 5px 5px"
    }
  }, [_c('div', {
    staticClass: "ui radio checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sensitivity),
      expression: "sensitivity"
    }],
    attrs: {
      "type": "radio",
      "value": "HIGH"
    },
    domProps: {
      "checked": _vm._q(_vm.sensitivity, "HIGH")
    },
    on: {
      "change": function($event) {
        _vm.sensitivity = "HIGH"
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "field",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('div', {
    staticClass: "ui radio checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sensitivity),
      expression: "sensitivity"
    }],
    attrs: {
      "type": "radio",
      "value": "MEDIUM"
    },
    domProps: {
      "checked": _vm._q(_vm.sensitivity, "MEDIUM")
    },
    on: {
      "change": function($event) {
        _vm.sensitivity = "MEDIUM"
      }
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "field",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('div', {
    staticClass: "ui radio checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sensitivity),
      expression: "sensitivity"
    }],
    attrs: {
      "type": "radio",
      "value": "LOW"
    },
    domProps: {
      "checked": _vm._q(_vm.sensitivity, "LOW")
    },
    on: {
      "change": function($event) {
        _vm.sensitivity = "LOW"
      }
    }
  }), _vm._v(" "), _vm._m(2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "six wide column"
  }, [_c('button', {
    class: _vm.dirty ? 'ui primary button' : 'ui disabled primary button',
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "ui basic button",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("Close ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("No Delay: "), _c('small', [_vm._v("You get alerts promptly after we detect a change in Amazon. "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("WARNING:")]), _vm._v(" This can result in a lot of notifications! Subscribe and Save can change frequently and repeatedly")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Moderate Delay "), _c('small', [_c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("[RECOMMENDED]")]), _vm._v(": We apply a small delay to the Subscribe and Save alerts so we can filter out short-lived changes. ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Strong Filtering: "), _c('small', [_vm._v("We only notify if Subscribe and Save option is lost or gained for a solid amount of time."), _c('br'), _vm._v(" Use this setting if you are getting too many Subscribe and Save alerts.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0431d599!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/SubscribeAndSaveConfig.vue
// module id = 715
// module chunks = 2